<template>
  <div>
    <b-button v-b-modal.modal-certificates>{{ $i18n.t("lang.label_select") }}</b-button>

    <b-modal id="modal-certificates" size="lg" :title="$t('lang.label_certificate_certificateCopy')" scrollable :ok-disabled="!userHasSelectedCertificate" @ok="onOkPressed">
      <search-certificates-form v-model="searchFilter"></search-certificates-form>
      <b-table
        id="table-existing-certs"
        :items="certificates"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        small
        hover
        selectable
        select-mode="single"
        @row-selected="onRowSelected"
        show-empty
      >
        <!-- Scoped slot for 'selected' state -->
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <b-icon aria-hidden="true" icon="check" font-scale="1.25"></b-icon>
            <span class="sr-only">{{ $t("lang.label_selected") }}</span>
          </template>
          <template v-else>
            <b-icon aria-hidden="true" icon="check" font-scale="1.25" style="visibility: hidden"></b-icon>
            <span class="sr-only">{{ $t("lang.label_notSelected") }}</span>
          </template>
        </template>
      </b-table>
      <b-pagination align="right" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="table-existing-certs"></b-pagination>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import * as utils from "../../utils";
import { BIcon, BIconCheck } from "bootstrap-vue";
import SearchCertificatesForm from "../search/SearchCertificatesForm";
export default {
  name: "SelectExistingCertificateModal",
  props: {
    /* Used for two-way binding */
    value: {
      type: Object
    },
    certificateTypeFilter: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      fields: [
        {
          key: "selected",
          label: ""
        },
        {
          key: "subjectDn",
          label: this.$t("lang.label_certificate_subjectDn"),
          sortable: true
        },
        {
          key: "certPublicKeyAlgorithm",
          label: this.$t("lang.label_certificate_publicKeyAlgorithm"),
          formatter: value => {
            return this.$t("lang.enum_publicKeyAlgorithm_" + value);
          },
          sortable: true
        },
        {
          key: "certSignatureAlgorithm",
          label: this.$t("lang.label_certificate_signatureAlgorithm"),
          formatter: value => {
            return this.$t("lang.enum_signatureAlgorithm_" + value);
          },
          sortable: true
        },
        {
          key: "validNotBefore",
          label: this.$t("lang.label_certificate_validNotBefore"),
          formatter: value => {
            return moment(String(value)).format(utils.constants.DATE_PATTERN);
          },
          sortable: true
        },
        {
          key: "validNotAfter",
          label: this.$t("lang.label_certificate_validNotAfter"),
          formatter: value => {
            return moment(String(value)).format(utils.constants.DATE_PATTERN);
          },
          sortable: true
        },
        {
          key: "certStatus",
          sortable: true,
          label: this.$t("lang.label_certificate_certStatus"),
          tdClass: this.getVariant,
          formatter: value => {
            return this.$t("lang.enum_certificateStatus_" + value);
          }
        }
      ],
      certificates: [],
      selected: []
    };
  },
  computed: {
    userHasSelectedCertificate() {
      return this.selected.length > 0;
    },
    searchFilter: {
      get: function() {
        return this.$store.getters["certificate/searchFilter"];
      },
      set: function(newValue) {
        this.$store.commit("certificate/set_searchFilter", newValue);
      }
    },
    selectedCertificate: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    rows() {
      return this.certificates.length;
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items;
    },
    onOkPressed() {
      if (this.selected && this.selected.length > 0) {
        this.selectedCertificate = this.selected[0];
      } else {
        this.selectedCertificate = null;
      }
    },
    getVariant(value) {
      if (value === "ACTIVE") {
        return "text-success font-weight-bold";
      } else if (value === "REVOKED") {
        return "text-warning font-weight-bold";
      } else {
        return "text-danger font-weight-bold";
      }
    },
    reloadTableWithSearchedData() {
      let tableContext = {
        currentPage: 1,
        perPage: 20,
        sortBy: null,
        sortDesc: null
      };
      const pageable = utils.buildPageableFromTableContext(tableContext);
      const searchCriteria = utils.buildSearchCriteriaArray(this.searchFilter);
      return this.$store
        .dispatch("certificate/searchCertificates", { pageable, searchCriteria })
        .then(response => {
          this.certificates = response.data.content;
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", "Search failed");
        });
    }
  },
  mounted() {
    // Fetch the newest 100 certificates, filtered by type
    const pageable = {
      page: 0,
      size: 100,
      sort: ["id,desc"]
    };
    const searchCriteria = [{ key: "certCryptoType", operation: "EQUALS", value: this.certificateTypeFilter, logicalOperation: "AND" }];

    return this.$store
      .dispatch("certificate/searchCertificates", { pageable, searchCriteria })
      .then(response => {
        this.certificates = response.data.content;
      })
      .catch(() => {
        this.$store.dispatch("alert/showFailureAlert", "Search failed");
      });
  },
  watch: {
    /**
     * Called whenever the search filter has changed. Should trigger a new search.
     */
    searchFilter: {
      // Start new search
      handler: function() {
        this.reloadTableWithSearchedData();
      }
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    BIcon,
    BIconCheck,
    SearchCertificatesForm
  }
};
</script>

<style scoped></style>
